import React, {useEffect, useRef, useState, useCallback} from 'react';
import {connect} from "react-redux";

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import {ArrowBack, ArrowForward} from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';

import moment from 'moment';
import {getItem} from '../../@opentripplanner/core-utils/src/storage';
import {findScheduleRouteForStop} from '../../actions/api';
import {getSchedulesRoutesHours, APP_BAR_HEIGHT, APP_FOOTER_HEIGHT} from '../../actions/ui';
import {getTimeFormat} from '../../@opentripplanner/core-utils/src/time';
import i18n from '../../../i18nSetup';
import Icon from '../narrative/icon'
import {useLocation} from "react-router-dom";
import { useFont } from '../../contexts/FontContext';
//import {getFormattedStopTime} from './stop-time';


function SchedulesViewer(props) {
  const {lineColor, lineNumber, targetTrip, stopName, stopId, routeId, schedules,textColor, timeFormat, stopViewerArriving, homeTimezone, stopTimes, direction} = props;
  const { currentFont } = useFont();
  const [travelDate, setTravelDate] = useState(props.travelDate ? moment(props.travelDate) : moment());
  const [schedulesList, setSchedulesList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const mountedRef = useRef();
  const location = useLocation();
  
  // More robust check for headless parameter
  const urlParams = new URLSearchParams(location.search);
  const isHeadless = urlParams.get('headless') === 'true';
  const isShowShell = !isHeadless;
  
  const appBarHeight = isShowShell ? APP_BAR_HEIGHT : 0;
  const appFooterHeight = isShowShell ? APP_FOOTER_HEIGHT : 4;

  window.onmousedown = function (event) {
    props.closeView();
  };

  const handleBackDay = () => {
    let date = moment(travelDate).subtract(1, "days");
    setTravelDate(date);
    getSchedulesRouteForStop(date);
  };

  const handleForwardDay = () => {
    let date = moment(travelDate).add(1, "days");
    setTravelDate(date);
    getSchedulesRouteForStop(date);
  };

  const getSchedulesRouteForStop = ((date) => {
    setIsLoading(true);
    props.findScheduleRouteForStop({
      stopId: stopId,
      travelDate: moment(date).lang('en').format('YYYYMMDD')
    }, {routes: routeId})
  });

  useEffect(() => {
    getSchedulesRouteForStop(travelDate);
  }, []);

  useEffect(() => {

    if (mountedRef.current) {
      setIsLoading(false);
      if (schedules?.length > 0) {
        let schedulesGroup = getSchedulesRoutesHours(schedules, null);
        setSchedulesList(schedulesGroup);
      } else {
        setSchedulesList([]);
      }
    } else {
      mountedRef.current = true;
    }

  }, [schedules]);

  const getContentDate = () => {
    let dateContent = moment(travelDate).format('DD.MM.YYYY');
    let lang = getItem('userLanguage') || 'he';
    switch (lang) {
      case "he":
        return dateContent+ ' יום ' + moment(travelDate).format('ddd');
      case "ar":
       return dateContent + ' يوم ' + moment(travelDate).format('dddd');
      case "ru":
        return dateContent + ' ' + moment(travelDate).format('dddd').charAt(0).toUpperCase() + moment(travelDate).format('dddd').substr(1).toLowerCase();
      case "en":
        return dateContent + ' ' + moment(travelDate).format('dddd');
      default:
        return dateContent + ' ' + moment(travelDate).format('dddd');
    }
  };

  return (
    <Paper variant="outlined" sx={{width: '100%', marginTop: `${appBarHeight + 1}px`,  height: `calc(100% - ${appBarHeight + appFooterHeight}px)`}}>
      <>
        <Box sx={{padding: '0px 20px', height: '100%'}}>
          <IconButton
            onClick={() => {
              props.closeView()
            }}
            size="large">
            <CloseIcon fontSize={"small"}/>
          </IconButton>
          <Grid container spacing={2} justifyContent="center" alignItems="center"
                sx={{height: '90%'}}>
            <Grid item xl container direction="column" spacing={2} justifyContent="center" alignItems={"center"} >
              {lineNumber && <Grid item>
                <Avatar style={{width:'unset',paddingInline:8,fontFamily: currentFont,height: 28, backgroundColor: lineColor,color:textColor}} variant="rounded">
                  <Typography align={'center'} variant="body1">
                    {lineNumber}
                  </Typography>
                </Avatar>
              </Grid>
              }
              <Grid item>
                {targetTrip && <Typography sx={{fontWeight: 600}} align={'center'} variant="body1">
                  {i18n.t('toDirect')} {targetTrip}
                </Typography>}
                {stopName && <Typography align={'center'} variant="body2">
                  {stopName}
                </Typography>}
              </Grid>
              <Grid item xs container justifyContent="center" alignItems="center">
                <Grid item xs={2} align={'center'}>
                  <IconButton
                    onClick={handleBackDay}
                    disabled={moment(moment(travelDate).format('YYYY-MM-DD')) <= moment(moment().format('YYYY-MM-DD'))}
                    size="large">
                    <ArrowBack fontSize={"small"} sx={{transform:(direction === 'rtl') ? 'scaleX(-1)': 'none'}}/>
                  </IconButton>
                </Grid>
                <Grid item xs={7}>
                  <Typography align={'center'} variant="body1">
                    {getContentDate()}
                  </Typography>
                </Grid>
                <Grid item xs={2} align={'center'}>
                  <IconButton
                    onClick={handleForwardDay}
                    disabled={moment(moment().add(1, "M").format('YYYY-MM-DD')) <= moment(moment(travelDate).format('YYYY-MM-DD'))}
                    size="large">
                    <ArrowForward fontSize={"small"} sx={{transform:(direction === 'rtl') ? 'scaleX(-1)': 'none'}}/>
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} justifyContent="center" alignItems="center" sx={{height: '70%', overflow: 'auto'}}>
              {
                isLoading ? (<Grid item xs={1} sx={{margin: 'auto'}}> <CircularProgress  size={24}/> </Grid>) : (
                  <Grid item>
                    {schedulesList?.length > 0 ? (<Box overflow="auto">{
                      schedulesList.map((groupList,index) => {
                        return (<Grid key={"group_" + index} item xs container alignItems="center" sx={{}}>
                          {groupList.schedules.map((currentSchedule,index) => {
                            return (<Grid 
                              key={"groupschedule_" + index}
                              item xs={3} justifyContent="center"
                                          alignItems="center">
                                <Grid item>
                                  <Box>
                                    <Typography variant="body2" sx={{marginBlockStart:2,marginTop:2,marginBottom:1}}>
                                      {moment(currentSchedule.expectedArrival).format('HH:mm')}
                                      {currentSchedule.wheelchairAccessible ? (<Icon type='wheelchair'></Icon>) : null}
                                    </Typography>
                                  </Box>
                                </Grid>
                                {/*<Grid item sx={{height: 19}}>
                                {
                                  currentSchedule.stopTime && <div>
                                    {getFormattedStopTime(currentSchedule.stopTime, homeTimezone, stopViewerArriving, timeFormat)}
                                  </div>
                                }
                              </Grid>*/}
                              </Grid>
                            )
                          })
                          }
                          <Grid item xs={12}>
                            <Divider/>
                          </Grid>
                        </Grid>)
                      })
                    }
                    </Box>) : (<Typography variant="body2" align={'center'}>
                      {i18n.t('emptySchedulesText')}
                    </Typography>)
                    }
                  </Grid>
                )
              }
            </Grid>
          </Grid>
        </Box>
      </>
    </Paper>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    schedules: state.otp.transitIndex.schedules,
    timeFormat: getTimeFormat(state.otp.config),
    homeTimezone: state.otp.config.homeTimezone,
    stopViewerArriving: state.otp.config.language.stopViewerArriving,
    direction: state.otp.config.dir
  }
};

const mapDispatchToProps = {
  findScheduleRouteForStop
};

export default connect(mapStateToProps, mapDispatchToProps)(SchedulesViewer)